<es-details-card [info]="info" [canEdit]="canEdit" [isMissing]="isEmpty" (edit)="goToEdit()">
  <div class="row flex-wrap" *ngIf="entrySummary.vesselName && !isAir && !isRail && !isTruck">
    <div class="col-12 col-sm-6 card-label">{{ "LABELS.VESSEL_NAME" | translate }}</div>
    <div class="col-12 col-sm-6">{{ entrySummary.vesselName }}</div>
  </div>
  <div class="row flex-wrap" *ngIf="entrySummary.trip">
    <div class="col-12 col-sm-6 card-label">
      {{ tripLabel | translate }}
    </div>
    <div class="col-12 col-sm-6">{{ entrySummary.trip }}</div>
  </div>
  <div class="row flex-wrap">
    <div class="col-12 col-sm-6 card-label">{{ "FORM_LABEL.TYPE" | translate }}</div>
    <div class="col-12 col-sm-6">{{ "FORM_LABEL." + enumShipmentType[entrySummary.type] | translate }}</div>
  </div>
  <div class="row flex-wrap">
    <div class="col-12 col-sm-6 card-label">{{ "LABELS.MODULE" | translate }}</div>
    <div class="col-12 col-sm-6">
      {{ "SUBMISSION_TYPE." + enumEntrySummarySubmissionType[entrySummary.submissionType] | translate }}
    </div>
  </div>
  <div *ngIf="isShowDutiesPaymentType" class="row flex-wrap">
    <div class="col-12 col-sm-6 card-label">{{ "LABELS.DUTIES_PAYMENT_TYPE" | translate }}</div>
    <div class="col-12 col-sm-6">
      {{ "DUTIES_PAYMENT_TYPE." + enumEntrySummaryDutiesPaymentType[entrySummary.dutiesPaymentType] | translate }}
    </div>
  </div>
  <div
    *ngIf="
      isShowDutiesPaymentType && entrySummary.dutiesPaymentType === enumEntrySummaryDutiesPaymentType.ACH && entrySummary.payerUnitNumber
    "
    class="row flex-wrap"
  >
    <div class="col-12 col-sm-6 card-label">{{ "LABELS.PAYER_UNIT_NUMBER" | translate }}</div>
    <div class="col-12 col-sm-6">
      {{ entrySummary.payerUnitNumber }}
    </div>
  </div>
  <div class="row flex-wrap" *ngIf="foreignPort && !isAir && !isRail && !isTruck">
    <div class="col-12 col-sm-6 card-label">{{ "FORM_LABEL.FOREIGN_PORT" | translate }}</div>
    <div class="col-12 col-sm-6">{{ foreignPort.code }} {{ foreignPort.portName }} {{ foreignPort.countryCode }}</div>
  </div>
  <div class="row flex-wrap" *ngIf="exportDate">
    <div class="col-12 col-sm-6 card-label">{{ "FORM_LABEL.EXPORT_DATE" | translate }}</div>
    <div class="col-12 col-sm-6">{{ exportDate | customDateByUtc }}</div>
  </div>
  <div class="row flex-wrap" *ngIf="entrySummary.portOfEntryCode">
    <div class="col-12 col-sm-6 card-label">{{ "FORM_LABEL.PORT_OF_ENTRY" | translate }}</div>
    <div class="col-12 col-sm-6">{{ portOfEntry ? portOfEntry.code + " " + portOfEntry.description : "" }}</div>
  </div>
  <div class="row flex-wrap" *ngIf="entrySummary.portOfUnladingCode && entrySummary.portOfEntryCode !== entrySummary.portOfUnladingCode">
    <div class="col-12 col-sm-6 card-label">{{ "FORM_LABEL.PORT_OF_UNLADING_ARRIVAL" | translate }}</div>
    <div class="col-12 col-sm-6">{{ portOfUnlading ? portOfUnlading.code + " " + portOfUnlading.description : "" }}</div>
  </div>
  <div class="row flex-wrap" *ngIf="entrySummary.arrivalDate">
    <div class="col-12 col-sm-6 card-label">{{ "LABELS.ARRIVAL_DATE" | translate }}</div>
    <div class="col-12 col-sm-6">{{ entrySummary.arrivalDate | customDateByUtc }}</div>
  </div>
  <div class="row flex-wrap" *ngIf="location">
    <div class="col-12 col-sm-6 card-label">{{ "FORM_LABEL.LOCATION_OF_GOODS" | translate }}</div>
    <div class="col-12 col-sm-6">{{ location.code }} {{ location.name }}</div>
  </div>
  <div class="row flex-wrap" *ngIf="stateOfDestination">
    <div class="col-12 col-sm-6 card-label">{{ "FORM_LABEL.STATE_OF_DESTINATION" | translate }}</div>
    <div class="col-12 col-sm-6">{{ stateOfDestination.description }}</div>
  </div>
  <div
    class="error-message"
    [ngClass]="message.severity"
    *ngFor="let message of currentCardValidationMessages"
    [innerHTML]="'BACK_ERROR.' + message.text | translate : message.params"
  ></div>
</es-details-card>
